var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M0 0h500v500H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.492 145.001c11.704 0 21.308 8.916 22.397 20.332l.103 2.168v165c0 11.69-8.916 21.307-20.332 22.397l-2.168.103h-225c-11.689 0-21.306-8.929-22.397-20.334l-.103-2.166v-165c0-11.703 8.929-21.307 20.334-22.397l2.166-.103h225zm-7.5 22.5h-210a7.505 7.505 0 00-7.379 6.153l-.121 1.347v129l21.6-21.585c8.241-8.24 21.267-8.755 30.106-1.545l1.709 1.545 21.585 21.585 66.6-66.585c8.241-8.24 21.267-8.755 30.106-1.545l1.709 1.545 51.585 51.585v-114a7.495 7.495 0 00-6.148-7.379l-1.352-.121zM197.5 205c12.435 0 22.5 10.065 22.5 22.5S209.935 250 197.5 250 175 239.935 175 227.5s10.065-22.5 22.5-22.5z",
    fill: "#7F7F7F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/imagePlaceholder.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };